var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0156 0.869531C16.819 0.415192 16.3701 0.122161 15.875 0.125H2.125C1.63073 0.125974 1.18345 0.418107 0.983881 0.8703C0.784314 1.32249 0.869944 1.84982 1.20234 2.21562L1.20859 2.22266L6.5 7.87266V13.875C6.49989 14.336 6.75349 14.7596 7.15983 14.9772C7.56618 15.1948 8.05933 15.1712 8.44297 14.9156L10.943 13.2484C11.291 13.0166 11.5001 12.626 11.5 12.2078V7.87266L16.7922 2.22266L16.7984 2.21562C17.1346 1.85125 17.2201 1.32113 17.0156 0.869531ZM10.5891 7.02188C10.3719 7.25202 10.2507 7.55626 10.25 7.87266V12.2078L7.75 13.875V7.87266C7.75073 7.55512 7.62998 7.24934 7.4125 7.01797L2.125 1.375H15.875L10.5891 7.02188Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ee1f616d2c23c781fd8df2e37beb1f83.svg";
export { ForwardRef as ReactComponent };